import { z } from 'zod';
import dayjs from 'dayjs';

const dateTimeRegex = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}Z$/;

export const dateTime = z.string().regex(dateTimeRegex, 'Nesprávný formát, očekávaný yyyy-mm-ddTHH:mm:ssZ').refine(val => {
    return dayjs(val).isValid();
  },
  { message: 'Neplatné datum' });
